module.exports = __webpack_public_path__ + "img/2-3.cd234b46.png";